import { render, staticRenderFns } from "./sidebar-toggle-icon.vue?vue&type=template&id=c55b20c2"
import script from "./sidebar-toggle-icon.vue?vue&type=script&lang=js"
export * from "./sidebar-toggle-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports